import { RichText } from '@sitecore-jss/sitecore-jss-nextjs';
import React from 'react'

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
// import { extractRelativeURLPath } from 'components/Shared/DomainSplit';
import Link from 'next/link';
import { DGAButton } from 'components/Shared/dga-button/DGAButton';

type ServiceItemProps = {
    resultItems:{
      Id: string;
      Title: string;
      Description: string;
      Sector: string;
      SectorId: string;
      Visits: number;
    }[];
    noItems:{
      value: string;
    };
    ServiceDetailsText: {
      value: string;
    };
    locale:string;
    ServiceDetailPageLink:{
      value: {
        href: string;
        text: string;
        anchor: string;
        linktype: string;
        class: string;
        title: string;
        target: string;
        querystring: string;
        id: string
      }
    } ;
    // sortItems: SortItem[];
    // order: number;
    // setOrder:any;
}
function ServiceItem(props:ServiceItemProps) {

    // const [selectedSortOption, setSelectedSortOption] = useState<any>({
    //     name: '',
    //     value: null,
    //   });

    // function changeSortMethod(e:any){
    //   setSelectedSortOption({name:props.sortItems[e].fields?.Title?.value, value: props?.sortItems[e]?.id})
    //   // console.log({name:props.sortItems[e].fields?.Title?.value, value: props?.sortItems[e]?.id})
    //   props.setOrder(e);
    // }



  //  useEffect(()=>{
  //     if(props?.order) {
  //        props.sortItems.map((item: SortItem, index:number) =>{
  //           if(item?.fields?.value?.value === props?.order) {
  //             setSelectedSortOption({name:props.sortItems[index].fields?.Title?.value, value:props?.sortItems[index]?.fields?.value?.value})
  //           }
  //        })
  //     } else {
  //       setSelectedSortOption({name:props.sortItems[0].fields?.Title?.value, value:props?.sortItems[0]?.fields?.value?.value})

  //     }
  //     console.log('selected sort option',selectedSortOption)
  //  },[])

  //  const findIndex  = (id:string): number => {
  //       let i:number = -1;
  //       props?.sortItems.forEach((item:SortItem, index:number) => {
  //            if( item?.id === id) {
  //             console.log(index)
  //             i = index;
  //           }

  //        });
  //        return i;
  //  }


    // useEffect(() => {
    //   if(props?.order) {
    //     props.sortItems.map((item: SortItem, index:number) =>{
    //        if(item?.fields?.value?.value === props?.order) {
    //          setSelectedSortOption({name:props.sortItems[index].fields?.Title?.value, value:props?.sortItems[index]?.id})
    //        }
    //     })
    //  } else {
    //    setSelectedSortOption({name:props.sortItems[0].fields?.Title?.value, value:props?.sortItems[0]?.id})
    //  }
    // }, [props?.locale])


    return (
        <>
             <div className='  relative w-full ml-auto md:py-10 py-5 md:mt-10 -mt-10 px-2 md:px-8 flex flex-col gap-5 overflow-hidden'>
                <div className='w-full flex justify-end '>
                  {/* <div className='w-fit relative hidden md:block'>
                      <DGADropdownInput
                        value={selectedSortOption.value ||props.sortItems[0].id}
                        options={props.sortItems.map((item) => ({ value: item.id, label: item.fields?.Title?.value }))}
                        maxHeight={300}
                        closeAfterSelect
                        onChange={(selected) => {
                          let i = findIndex(selected as string) ;
                         changeSortMethod(i);
                        }}
                        dropdownTrigger={{
                          name: selectedSortOption,
                          placeholder: '',
                          InputSize: "lg",
                        }}

                      />
                  </div> */}
                </div>
                { props?.resultItems.map((item:any, index) => (
                  <Link  href={item?.itemPath} target={props?.ServiceDetailPageLink?.value?.target}>
                    <div key={index} className=' animate-top-dga bg-white p-5 flex flex-col justify-between gap-5 cursor-pointer border-[1px] border-[#D2D6DB] rounded-lg'>
                        <div className='flex flex-col gap-4'>
                            <h3 className='text-[#2E2E2E] font-bold text-2xl text-start' >{item?.Title}</h3>
                            <RichText className="text-[#919191] font-normal text-base w-[80%] line-clamp-3"  field={ {value: item?.Description}} />
                        </div>
                        <div className='w-fit bg-[#F9FAFB] text-xs px-1 py-1 text-center rounded-sm border-[1px] border-[#E5E7EB]'>
                            <p className='text-[#1F2A37]' >{ item?.Sector }</p>
                        </div>
                        <div className='w-fit py-2 text-center '>
                              <DGAButton type="submit" buttonContent={props?.ServiceDetailsText?.value}
                                   size="lg" variant='secondarySolid' />
                        </div>
                    </div>
                    </Link>
                ))}
                { props?.resultItems?.length === 0 &&
                 <div className='no-items-found text-center text-[20px] text-[#6E7182] py-40 px-10' >{props.noItems.value}</div>
                }
                {/*--------------------------------- sort dropdown -----------------------------------------------*/}
                {/* <div className={` absolute top-4 z-50 w-fit min-w-[100px] ${props.locale == 'en' ? 'right-20' :'left-20' } `}>

                </div> */}
                {/* ---------------------------------------------------------------------------------------------- */}

            </div>




        </>
    )
}

export default ServiceItem

// type SortItem = {
//   id: string;
//   url: string;
//   name: string;
//   displayName: string;
//   fields: {
//       Title: {
//           value: string;
//       },
//       value: {
//           value: number;
//       }
//   }
// }
